import { Component, viewChild } from '@angular/core';
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { SectionHeaderComponent } from '../section-header/section-header.component';
import { FaqEntry } from '../../faq/faq.interfaces';
import { homeData } from '../../faq/faq.data';
import { FaqEntryComponent } from '../../faq/faq-entry/faq-entry.component';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-faq-section',
  standalone: true,
  imports: [
    SectionHeaderComponent,
    FaqEntryComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
  templateUrl: './faq-section.component.html',
})
export class FaqSectionComponent {
  faqEntries: FaqEntry[] = homeData();
  accordion = viewChild.required(MatAccordion);
}
